import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { wcagOptions } from "./wcag";
import { bookingFormCommon } from "./c005-bookingform-common";

export class newsletterWidget{
	private $newsletterEmail: string = '';
	private $newsletterManageEmail: string = '';
	private $newsletterError:Array<string> = [];
	private $newsletterManageError:Array<string> = [];
	private wcag = new wcagOptions();

	$scope: any = $('.newsletter-container');
	$newsletterWidgetForm: any = $('.newsletter-widget--holder');
	$newsletterValidator: any = $('#newsletter-validator');
	$newsletterEmailInput: any = $('#newsletterEmail');
	$newsletterPreferredCity: any = $('#preferredCity');
	$newsletterCheckbox: any = $('#newsletterTC');
	$newsletterCheckboxMob: any = $('#newsletterTCMob');
	$newsletterSubmitBtn: any = $('#newsletterSubmit');
	$newsletterErrorValidation: any = $('.newsletter-error--validation');
	$newsletterWidgetSuccess: any = $('.newsletter-widget--success');

	$newsletterManageErrorValidation: any = $('.manage-error--validation');
	$newsletterManageValidator: any = $('#newsletter-validator--manage');
	$newsletterManageEmailInput: any = $('#newsletterManageEmail');
	$newsletterManageSubmitBtn: any = $('#newsletterManageSubmit');

	$error:Array<any>;

	preferredcitylist(): any {
		let defer:any = $.Deferred();
		$.get('/content/mas-admin/ond/getService.Newsletter.json')
		.done((data:any) => {
			var dataParse:any = null;
			if (typeof data === 'string') {
				dataParse= JSON.parse(data);
			}
			else {
				dataParse = data;
			}
			var airportListResponse = dataParse.response;
			var listItems = "<option value=''> </option>";
			for (var key in airportListResponse) {
				listItems += "<option value='" + airportListResponse[key].airportCode + "'>" + airportListResponse[key].airportName + ", " + airportListResponse[key].countryName + " (" + airportListResponse[key].airportCode + ")" +"</option>";
			}

			defer.resolve(listItems);
		})
		.fail((error:any) => {
			defer.reject(error);
		});
		return defer.promise();
	}

	validateEmail($newsletterEmail:string): boolean {
		let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
				return emailReg.test($newsletterEmail);
	}

	validateManageEmail($newsletterManageEmail:string): boolean {
		let emailManageReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
				return emailManageReg.test($newsletterManageEmail);
	}

	newsLetterError(): void {
		var _this = this;
		_this.$error = [];
		$('.newsletter-error--validation').show();
		$('#newsletter-validator').addClass('has-error');
		var $newsletterError = "Oops! Your request was unsuccessful. Please try again.";
		_this.$error.push($newsletterError);
		$("#newsletter-validator").text(_this.$error.join(', '));
	}

	newsLetterManageError(): void {
		var _this = this;
		_this.$newsletterManageError = [];
		$(".newsletter-widget--manage").hide();
		$(".newsletter-widget--notsubscribed").show();

		// $('.manage-error--validation').show();
		// $('#newsletterManageEmail').addClass('has-error');
		// var $newsletterManageError = "Oops! Your request was unsuccessful. Please try again.";
		// _this.$newsletterManageError.push($newsletterManageError);
		// $("#newsletter-validator--manage").text(_this.$newsletterManageError.join(', '));
	}

	submitNewsletterForm(newsLetterEmail:string, preferredCity:string): void {
		var _this = this;
		document.cookie = "userEmail="+newsLetterEmail +";path=/";
		if (preferredCity && preferredCity!='') {
			document.cookie = "preferredCity="+preferredCity+";path=/";
		}
		var $data = {
			email: newsLetterEmail,
			city: '',
			action:'manage',
			language:$("#lang_js").val(),
			country:$("#country_js").val()
		};
		if (preferredCity != '') {
			$data['city'] = preferredCity;
			$data['action'] = 'create';
		}
		if(window.location.href.indexOf('holidays') >0){
			$data['signup_source'] = "MASNLSignUpMHH";
		}else{
			$data['signup_source'] = "MASNLSignUPWidget";
		}

		let _self = this;

		if (_self.getUrlVars("acemail") && (_self.getUrlVars("acemail")=="new" ||
			 (_self.getUrlVars("acemail")=="resignup" && _self.getUrlVars("profile")=="new"))) {
				$data['action'] = 'create';
				$data['resendtrue'] = 'true';
				$data['city'] = _this.readValueFromCookie('preferredCity');
		} else if (_self.getUrlVars("acemail") && (_self.getUrlVars("acemail")=="exist" || _self.getUrlVars("acemail")=="resignup")) {
			$data['action'] = 'exist';
		} else if (_self.getUrlVars("acappexec") && _self.getUrlVars("acappexec")=="true") {
			$data['action'] = 'acappexec';
		}

		$.ajax({
			type: 'POST',
			url: '/bin/services/new/newsletter',
			data: $data,
			success: function(json:any){
				json = JSON.parse(json);
				console.log("##Successful: " + json);
				if (json.success==true) {
					console.log("Success"+ json);
					if (json.redirectURL) {
						window.location.replace(json.redirectURL);
					} else {
						$('.newsletter-widget--success .email-details > span > a').attr('href',"mailto:" + newsLetterEmail);
						$('.newsletter-widget--success .email-details > span > a').text(newsLetterEmail);
						$('.newsletter-widget--success').show();
						$('.newsletter-widget--holder').hide();
					}
				} else {
					console.log("Error while submitting form" + json);
					if ($data['action'] =="manage") {
						_this.newsLetterManageError();
					} else {
						_this.newsLetterError();
					}

				}
			},
			error: function(error:any) {
				console.log("Error while submitting form", error);
			}
		});
	}

	getUrlVars(url:string):any {
		let vars:Array<any> = [];
		let hash:any;
		let hashes = url.slice(url.indexOf('?') + 1).split('&');
		for(let i = 0; i < hashes.length; i++)
		{
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}

	initSelectize(listItems: string): void {
		let _self = this;
		let $preferredCitySel: any = $('#preferredCity');
		let $preferredCity   : any = $('.preferredCity');
		$preferredCitySel.html(listItems);
		$preferredCitySel.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($preferredCitySel[0].selectize);
			},
			onFocus: function() {
				
				$preferredCity.find('.booking-form--title').addClass('input-filled');
				$preferredCity.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$preferredCitySel.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$preferredCitySel.parent().find('.booking-form--title').removeClass('has-error');
			},
			onChange: function() {
				$preferredCity.find('.booking-form--title').addClass('input-filled');
				$preferredCity.find('.selectize-control.single .selectize-input').addClass('select-filled');
			},
			onBlur: function(){
				let $preferredCityChange = $preferredCitySel.find('option:selected').text();
				if ($preferredCityChange == ''){
					$preferredCity.find('.booking-form--title').removeClass('input-filled');
					$preferredCity.find('.selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$preferredCity.find('.booking-form--title').addClass('input-filled');
					$preferredCity.find('.selectize-control.single .selectize-input').addClass('select-filled');
				}
			},
			render: {
				item: function (item: any, escape: any) {
					return '<div>' +
						(item.text ? '<span class = "airportname">' + escape(item.text.split(',')[0]) + ',</span> ' + escape(item.text.split(',')[1]) : '') +
						'</div>';
				},
				option: function (item: any, escape: any) {
					return '<div>' +
						(item.text ? '<span class = "airportname">' + escape(item.text.split(',')[0]) + ',</span> ' + escape(item.text.split(',')[1]) : '') +
						'</div>';
				}
			}
		});
	}

	newsletterForm(): void {
		let _self = this;
		if (_self.$scope.length == 0) { return; }
		_self.$scope.find('.newsletterTandC').show();
		_self.$newsletterSubmitBtn.click((evt:any) => {
			let _self = this;
			evt.preventDefault();
			this.$newsletterError = [];
			_self.$newsletterErrorValidation.show();

			let $newsletterEmail = _self.$newsletterEmailInput.val();

			if ((!(this.validateEmail($newsletterEmail))) || $newsletterEmail == ''){
				let $newsletterEmailValidate:any = _self.$newsletterEmailInput.attr('data-email');
				this.$newsletterError.push('<strong>'+_self.$newsletterEmailInput.parent().find('.booking-form--title').text()+':</strong> '+$newsletterEmailValidate);
				_self.$newsletterEmailInput.addClass('has-error');
				_self.$newsletterEmailInput.parent().find('.booking-form--title').addClass('has-error');
			} else {
				_self.$newsletterEmailInput.removeClass('has-error');
				_self.$newsletterEmailInput.parent().find('.booking-form--title').removeClass('has-error');
			}

			if (_self.$newsletterPreferredCity.val() == ''){
				_self.$newsletterPreferredCity.parent().find('.selectize-control .selectize-input').addClass('has-error');
				_self.$newsletterPreferredCity.parent().find('.booking-form--title').addClass('has-error');
				let $preferredCityValidate:any = _self.$newsletterPreferredCity.attr('data-preferredcity');
				this.$newsletterError.push('<strong>'+_self.$newsletterPreferredCity.parent().find('.booking-form--title').text()+':</strong> '+$preferredCityValidate);
			} else {
				_self.$newsletterPreferredCity.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				_self.$newsletterPreferredCity.parent().find('.booking-form--title').removeClass('has-error');
			}

			let $newsletterTandC;

			if (window.innerWidth < 768) {
				$newsletterTandC = _self.$newsletterCheckboxMob.is(':checked');
				
				if (!$newsletterTandC) {
					let $newsletterTandCValidate:any = _self.$newsletterCheckboxMob.attr('data-tandc');
					this.$newsletterError.push('<strong>'+_self.$newsletterCheckboxMob.parent().parent().find('.booking-form--title').text()+':</strong> '+$newsletterTandCValidate);
					_self.$newsletterCheckboxMob.parent().addClass('has-error');
				} else {
					_self.$newsletterCheckboxMob.parent().removeClass('has-error');
				}
			} else {
				$newsletterTandC = _self.$newsletterCheckbox.is(':checked');

				if (!$newsletterTandC) {
					let $newsletterTandCValidate:any = _self.$newsletterCheckbox.attr('data-tandc');
					this.$newsletterError.push('<strong>'+_self.$newsletterCheckbox.parent().parent().find('.booking-form--title').text()+':</strong> '+$newsletterTandCValidate);
					_self.$newsletterCheckbox.parent().addClass('has-error');
				} else {
					_self.$newsletterCheckbox.parent().removeClass('has-error');
				}
			}		

			let $validationContainer:any = _self.$newsletterValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=this.$newsletterError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + this.$newsletterError[i] + '</li>');
			}

			if (this.validateEmail($newsletterEmail) || _self.$newsletterEmailInput.val() != '' || _self.$newsletterPreferredCity.val() != '' || $newsletterTandC){
				if (!($('.preferredCity .selectize-control .selectize-input').hasClass('has-error') || $('.newsletterEmail .booking-form--title').hasClass('has-error') )){

					let prefCity:string = $('#preferredCity').val();

					if (prefCity == ''     || prefCity == undefined){
						prefCity=$('#preferredCity-js').val();
					}
					if (window.innerWidth < 768) {
						if (!($('#newsletterTCMob').parent().hasClass('has-error'))){
							_self.$newsletterErrorValidation.hide();
							_self.submitNewsletterForm($newsletterEmail, prefCity);
						}
					}else{
						if (!($('#newsletterTC').parent().hasClass('has-error'))){
							_self.$newsletterErrorValidation.hide();
							_self.submitNewsletterForm($newsletterEmail, prefCity);
						}
					}
					
				}
			}
		});

		_self.$newsletterManageSubmitBtn.click((evts:any) => {
			let _self = this;
			evts.preventDefault();
			this.$newsletterManageError = [];
			_self.$newsletterManageErrorValidation.show();
			let $newsletterManageEmail = _self.$newsletterManageEmailInput.val();
			if ((!(this.validateManageEmail($newsletterManageEmail))) || $newsletterManageEmail == ''){
				let $newsletterManageEmailValidate:any = _self.$newsletterManageEmailInput.attr('data-emailmanage');
				this.$newsletterManageError.push('<strong>'+_self.$newsletterManageEmailInput.parent().find('.booking-form--title').text()+':</strong> '+$newsletterManageEmailValidate);
				_self.$newsletterManageEmailInput.addClass('has-error');
				_self.$newsletterManageEmailInput.parent().find('.booking-form--title').addClass('has-error');
			} else {
				_self.$newsletterManageEmailInput.removeClass('has-error');
				_self.$newsletterManageEmailInput.parent().find('.booking-form--title').removeClass('has-error');
			}

			let $validationContainer:any = _self.$newsletterManageValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
				let $validationMessagelist:any = $validationContainer;

				for (var i=0, len=this.$newsletterManageError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + this.$newsletterManageError[i] + '</li>');
				}
			if (this.validateManageEmail($newsletterManageEmail) || _self.$newsletterManageEmailInput.val() != ''){
				if (!($('.newsletterManageEmail .booking-form--title').hasClass('has-error'))){
					_self.$newsletterManageErrorValidation.hide();
					_self.submitNewsletterForm($newsletterManageEmail, '');
				}
			}
		});

		_self.$scope.find('.manage-your--profile').click(function(evt:any){
			evt.preventDefault();
			$('.newsletter-widget--holder').hide();
			$('.newsletter-widget--success').hide();
			$('.newsletter-widget--manage').show();
			$('.newsletter-widget--existing').hide();
			$('.newsletter-widget--notsubscribed').hide();
		});

		_self.$scope.find('.subscribe-now').click(function(e:any){
			e.preventDefault();
			$('.newsletter-widget--manage').hide();
			$('.newsletter-widget--holder').show();
			$('.newsletter-widget--success').hide();
			$('.newsletter-widget--existing').hide();
			$('.newsletter-widget--notsubscribed').hide();
		});

		_self.$scope.find('.newsletter-widget--notsubscribed a').click(function(e:any) {
			e.preventDefault();
			$('.newsletter-widget--holder').show();
			$('.newsletter-widget--success').hide();
			$('.newsletter-widget--manage').hide();
			$('.newsletter-widget--existing').hide();
			$('.newsletter-widget--notsubscribed').hide();
		});

		_self.$scope.find('#newsletterResend').click(function(e:any) {
			e.preventDefault();

			let $newsletterEmail = $('.newsletter-widget--success .email-details > span > a').text();
			let $preferredCity   = $('#preferredCity').val(); // todo: get city for resend
			let prefCity         = $('#preferredCity').val();

			if (prefCity == '' || prefCity == undefined){
				prefCity=$('#preferredCity-js').val();
			}
			_self.submitNewsletterForm($newsletterEmail, prefCity);
		});

		_self.$scope.find('.manage-your--profile').click(function(e:any) {
			e.preventDefault();
			$('.newsletter-widget--holder').hide();
			$('.newsletter-widget--success').hide();
			$('.newsletter-widget--manage').show();
		});

		_self.$scope.find('.subscribe-now').click(function(e:any) {
			e.preventDefault();
			$('.newsletter-widget--manage').hide();
			$('.newsletter-widget--holder').show();
			$('.newsletter-widget--success').hide();
		});
	}

	newsletterFormSelect() {
		$('#recipient__countrycallingcode').selectize();
		$('#recipient_location__countryCode').selectize();
		$('#recipient__podepone').selectize();
		$('#recipient__podeptwo').selectize();
		$('#recipient__podepthree').selectize();
	}

	readValueFromCookie(name:string):any {
		var json="";
		var ca = document.cookie.split(';');

		name = name + "=";

		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length,c.length);
			};
		}
		return json;
	}
}

let scope:Element = document.querySelector('.newsletter-container');
if (scope){
	try {
		let bookingformcommon = new bookingFormCommon();
		let newsletterwidget = new newsletterWidget();

		$.when(window['ibeOnDList']).done((listData: any) => {
			console.log('%cc014newsletter%c ond done', 'background-color: yellow', 'background-color: initial');
			let listItems:string = bookingformcommon.parseNewsletterListItems(listData);
			newsletterwidget.initSelectize(listItems);
			if ($('.newsletter-widget--success').length) {
				if ($('.enrich-revamp').length == 0) {
					document.querySelector('.newsletter-container').scrollIntoView();
				}
			}			
		});
		newsletterwidget.newsletterForm();
	} catch(e) {console.error(e);}
}
